import { render, staticRenderFns } from "./fixShopList.vue?vue&type=template&id=12065ee6&scoped=true&"
import script from "./fixShopList.vue?vue&type=script&lang=js&"
export * from "./fixShopList.vue?vue&type=script&lang=js&"
import style0 from "./fixShopList.vue?vue&type=style&index=0&id=12065ee6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12065ee6",
  null
  
)

export default component.exports